import { Autocomplete, Box, Button, Checkbox, Chip, Grid, Paper, Stack, TextField, Typography } from "@mui/material";
import { useState } from "react";
import DropDownLoading from "../frames/dropdown_loading";
import DeleteIcon from '@mui/icons-material/Delete';
import { requestPermission, deleteScope, getUserScope } from "./admin_helper";
import { resetCache } from "../frames/common";

function AuthAdmin({ user, permission, formLoading, formError }) {
    const [userPermissionList, setUserPermissionList] = useState([]);
    const [selectedPermissions, setSelectedPermissions] = useState([]);

    const validateInputs = () => {
        return true;
    }

    const handleScopeDelete = (user, scope) => {
        if (!user || !scope) return;
        formLoading(true);
        deleteScope(user, scope).then((res) => {
            formError({ "severity": "success", "message": "The user access is removed." })
            formLoading(false);
            setUserPermissionList(userPermissionList.filter((item) => item.auth_name !== scope));
            resetCache();
        }).catch((err) => {
            formError({ "severity": "warning", "message": err.message })
            formLoading(false);
        });
    }

    const handleUserChange = (event) => {
        if (!event.target.value) return;
        formLoading(true);
        getUserScope(event.target.value).then((res) => {
            formLoading(false);
            setUserPermissionList(res);
        }).catch((err) => {
            formLoading(false);
            console.error(err);
        });
    }

    const handleSubmit = (event) => {
        event.preventDefault();
        const data = new FormData(event.currentTarget);
        const userid = data.get("userid");
        // const permission = data.getAll("permission");
        const permission = selectedPermissions.map(item => item.auth_name).join(',');

        if (userid.length === 0) {
            formError({ "severity": "warning", "message": "The selected user or permission is not valid." })
            return;
        }

        formLoading(true);
        requestPermission(userid, permission).then((res) => {
            resetCache();
            formLoading(false);
            const tmp = selectedPermissions.map(item => { return { username: userid, auth_name: item.auth_name }; });
            setUserPermissionList([...userPermissionList, ...tmp]);
            formError({ "severity": "success", "message": "You have successfully updated the permissions for user @" + userid })
        }).catch((err) => {
            formLoading(false);
            formError({ "severity": "error", "message": err.message })
        });
    }
    return (
        <Box size={{ xs: 12, sm: 10 }} component="form" onSubmit={handleSubmit}>
            <Grid container spacing={2} component={Paper} sx={{ p: 2 }}>
                <Grid size={{ xs: 12, sm: 6 }}>
                    <Autocomplete
                        disablePortal
                        noOptionsText={<DropDownLoading title="Loading users ..." />}
                        options={user === null ? [] : user}
                        getOptionLabel={(option) => option.username}
                        onBlur={handleUserChange}
                        renderOption={(props, option) => {
                            const { key, ...optionProps } = props;
                            return (
                                <Box key={key} component="li" {...optionProps} >
                                    <Typography variant="subtitle1" color="primary" component={"div"}>
                                        {option.username} <Typography variant="caption" color="secondary" >{option.role}</Typography>
                                    </Typography>
                                </Box>
                            );
                        }}
                        renderInput={(params) => <TextField {...params} variant="outlined" name="userid" fullWidth type="text" placeholder="User" label="User" />}
                    />
                </Grid>
                <Grid size={{ xs: 12, sm: 6 }}>
                    <Autocomplete
                        disablePortal
                        multiple
                        disableCloseOnSelect
                        onChange={(event, newValue) => setSelectedPermissions(newValue)}
                        noOptionsText={<DropDownLoading title="Loading permission ..." />}
                        options={permission === null ? [] : permission}
                        getOptionLabel={(option) => option.auth_name}
                        renderOption={(props, option, { selected }) => {
                            const { key, ...optionProps } = props;
                            return (
                                <Box key={key} component="li" {...optionProps} >
                                    <Checkbox checked={selected} />
                                    <Typography variant="subtitle2" color="secondary" fontWeight={"bold"} component={"div"}>
                                        {option.auth_name}
                                        <Typography variant="subtitle2" fontSize={12} color="info">{option.description}</Typography>
                                    </Typography>
                                </Box>
                            );
                        }}
                        renderInput={(params) => <TextField {...params} variant="outlined" name="permission" fullWidth type="text" placeholder="Permission" label="Permission" />}
                    />
                </Grid>
                <Grid size={{ xs: 12, sm: 12 }}>
                    <Stack direction="row" sx={{ flexWrap: "wrap" }}>
                        {
                            userPermissionList.map((item, idx) =>
                                <Box sx={{ p: 0.2 }} key={idx}><Chip label={item.auth_name} deleteIcon={<DeleteIcon />} variant="outlined" color="secondary" onDelete={() => { handleScopeDelete(item.username, item.auth_name); }} /></Box>
                            )
                        }
                    </Stack>
                </Grid>
                <Grid size={{ xs: 12, sm: 12 }}>
                    <Button type="submit" variant="contained" fullWidth onClick={validateInputs} color="info" style={{ textTransform: "none" }}>Add Permission</Button>
                </Grid>
            </Grid>
        </Box>
    );
}

export default AuthAdmin;